import { controls, grouped } from "../../controls";
import moment from "moment";

const suspecioustxn = {
  label: "Suspecious Transactions",
  starting: true,
  url: "suspecioustxn",
  pageLabel: "Suspecious Transactions",
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", label: "Branch" }),
    ...controls.oc({ tab: "filter", length: 4, c: "Branch", defaultValue: "assigned_branch", placeHolder: "Branch Code", name: "branch_code", fastpath: "branches" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "branch_display" }),


    ...controls.displayText({ tab: "filter", label: "Voucher Type" }),
    ...controls.VoucherType({ tab: "filter" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),


    ...controls.magicDateLabel({ tab: "filter", label: "From Date", target: "from_date" }),
    ...controls.magicDate({ tab: "filter", name: "from_date", dateType: "ontype" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),

    ...controls.magicDateLabel({ tab: "filter", label: "To Date", target: "to_date" }),
    ...controls.magicDate({ tab: "filter", name: "to_date", dateType: "ontype" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),



    ...grouped.iterative("advance")

  ],
  form: [],


  history: {
    perPage: 10,
    reportHeader: "Suspecious Transactions",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: false,
    displayColumns: [
      {
        Header: "Date",
        accessor: "batchno",
        widthRecon: { size: 6 }
      },
      {
        Header: "Batch No",
        accessor: "cardno",
        widthRecon: { size: 19, padder: " ", align: "left" }
      },
      {
        Header: "Ac No",
        accessor: "rrn",
        widthRecon: { size: 12, padder: "0", align: "right" }
      },
      {
        Header: "Name",
        accessor: "actype",
        // accessor: d=>d.actype=='11' ? '10' : d.actype=='1' ? '10' : d.actype=='0' ? '10' : d.actype,
        widthRecon: { size: 2 }
      },
      {
        Header: "Amount",
        accessor: "acno",
        widthRecon: { size: 18, padder: "0", align: "right" }
      },
      {
        Header: "Transaction Type",
        accessor: "actype",
        widthRecon: { size: 2 }
      },
      {
        Header: "Reason",
        accessor: "actype",
        widthRecon: { size: 2 }
      }
    ]
  }
};

export default suspecioustxn;